import React from "react";
import ReactDOM from "react-dom";
import App from "./App";

window.initApp = ({ theme, amplitude, brandName, logo }) =>
  ReactDOM.render(
    <App theme={theme} amplitudeConfig={amplitude} brandName={brandName} logo={logo} />,
    document.getElementById("root"),
  );
